export { default as EProtectEncryption } from './eprotect-encryption';
